import { render } from "./ResultTable.vue?vue&type=template&id=52093000&ts=true"
import script from "./ResultTable.vue?vue&type=script&lang=ts"
export * from "./ResultTable.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__